import script from "./defaultInput.vue?vue&type=script&setup=true&lang=js"
export * from "./defaultInput.vue?vue&type=script&setup=true&lang=js"

import "./defaultInput.vue?vue&type=style&index=0&id=7c4bc8a7&scoped=true&lang=postcss"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4bc8a7"]])

export default __exports__